"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TickCirclePendingDownloadIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  ...otherProps,
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: color,
      fillRule: "nonzero",
      transform: "translate(-523 -559)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(524.5 560)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M10.509-.935h.047c6.35 0 11.563 5.084 11.563 11.435 0 6.173-4.864 11.21-10.968 11.488l-.026.004-1.179.032-.168.013v-.01l-.136.006a1 1 0 01-.925-.955l.002-.117a1 1 0 011.072-.923l-.089-.001.22-.017c.112-.007.226-.012.342-.015L10.62 20a9.5 9.5 0 009.5-9.5c0-5.156-4.171-9.288-9.293-9.431l-.27-.004v-.003l-.047.003h-1a1 1 0 110-2zM5.036 19.583a1 1 0 011.336-.464l.9.436a1 1 0 11-.872 1.8l-.9-.436a1 1 0 01-.464-1.336zM2.01 16.811a1 1 0 011.412.08l.666.746a1 1 0 11-1.492 1.332l-.666-.746a1 1 0 01.08-1.412zm-1.722-3.63a1 1 0 011.28.602l.338.941a1 1 0 01-1.881.677l-.34-.94a1 1 0 01.603-1.28zM.054 9.169a1 1 0 01.962 1.036l-.037 1a1 1 0 01-2-.075l.038-1A1 1 0 01.054 9.17zm-.085-3.21a1 1 0 111.832.802l-.4.916a1 1 0 11-1.833-.802zm2.563-3.678a1 1 0 111.388 1.44l-.72.694a1 1 0 11-1.388-1.44zM6.207-.103a1 1 0 11.749 1.854l-.928.375A1 1 0 115.28.27z"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M10.396 4.492a.77.77 0 01.763.673l.006.096v4.905l1.24-1.288a.77.77 0 011.008-.087l.08.067a.77.77 0 01.087 1.008l-.067.08-2.587 2.684a.77.77 0 01-1.044.059l-.073-.069-2.54-2.734a.769.769 0 011.05-1.119l.077.072 1.23 1.325V5.261c0-.425.345-.769.77-.769z"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "10.502",
          height: "1.589",
          x: "5.249",
          y: "14.152",
          rx: "0.794"
        })]
      })
    })
  })]
});

TickCirclePendingDownloadIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = TickCirclePendingDownloadIcon;
exports.default = _default;